"use strict";

exports.__esModule = true;
exports["default"] = Tablet;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Tablet(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M362.886 1H149.098c-29.133 0-52.747 23.614-52.747 52.755V458.233c0 29.141 23.614 52.768 52.747 52.768h213.788c29.136 0 52.764-23.627 52.764-52.768V53.755C415.649 24.614 392.021 1 362.886 1zM285.66 477.508a3.185 3.185 0 0 1-3.172 3.172h-52.973a3.185 3.185 0 0 1-3.172-3.172v-14.693a3.186 3.186 0 0 1 3.172-3.173h52.973a3.186 3.186 0 0 1 3.172 3.173v14.693zm92.536-46.991h-244.38V57.651c0-8.826 7.187-16.009 16.013-16.009h212.337c8.848 0 16.03 7.183 16.03 16.009v372.866z",
    fill: "#484848"
  }));
}